import { useState, useEffect } from 'react';
import { PERMISSION_INITIAL_STATE, PERMISSION_STATUS } from "./constants.js";

export const useCamera = () => {
  const [status, setStatus] = useState(PERMISSION_INITIAL_STATE);
  const [ cameraStream, setCameraStream] = useState(null);

  const startCamera = async () => {
    try {
      setStatus({status: PERMISSION_STATUS.LOADING, message: ""});
      let front = false;
      const constrains = {video: { facingMode: (front ? "user" : "environment") } };
      const stream = await navigator.mediaDevices.getUserMedia(constrains);
      setCameraStream(stream);
      setStatus({status: PERMISSION_STATUS.CORRECT, message: ""});
    } catch(error) {
      let message;
      if (error.name == "NotReadableError" || error.name == "TrackStartError") {
        //webcam or mic are already in use 
        message = error.message
      } else if (error.name == "NotAllowedError" || error.name == "PermissionDeniedError") {
        //permission denied in browser 
        message = error.message + " -----> Settings Phone App >> Chrome/Safari >> Camera >> Confirm that 'Ask' or 'Allow' is checked >> Go back to the web page and refresh it"
      } else {
        message = error.message
      }
      setStatus({status: PERMISSION_STATUS.ERROR, message});
    }
  }

  useEffect(() => {
    return () => {
      if(cameraStream){
        cameraStream.getTracks().forEach(track => {
          track.stop();
        });
      }
    }
  }, [cameraStream]);

  return {
    cameraStream,
    status,
    startCamera,
  };
}
